import React, { useState } from "react";
import ThemeToggle from "./ThemeToggle";
import { Icon } from '@iconify/react';

const Navbar = ({ activeSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const getLinkClass = (sectionId) => {
    const isActive = activeSection === sectionId;
    return `text-black dark:text-white hover:text-gray-600 dark:hover:text-gray-400 transition-colors duration-300 block py-2 px-4 ${
      isActive ? 'text-yellow-400 dark:text-yellow-400 font-bold' : ''
    }`;
  };

  const navLinks = (
    <>
      <li><a href="#about" onClick={() => setIsMenuOpen(false)} className={getLinkClass("about")}>About Me</a></li>
      <li><a href="#projects" onClick={() => setIsMenuOpen(false)} className={getLinkClass("projects")}>Projects</a></li>
      <li><a href="#education" onClick={() => setIsMenuOpen(false)} className={getLinkClass("education")}>Education</a></li>
      <li><a href="#social" onClick={() => setIsMenuOpen(false)} className={getLinkClass("social")}>Social</a></li>
    </>
  );

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  const [hasScrolled, setHasScrolled] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`bg-white dark:bg-neutral-800 p-4 sticky top-0 z-50 transition-shadow duration-300 ${
      hasScrolled ? 'shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)] dark:shadow-[0_4px_6px_-1px_rgba(255,255,255,0.1)]' : ''
    }`}>
      <div className="max-w-7xl mx-auto relative flex justify-center items-center">
        
        <ul className="hidden md:flex justify-center space-x-8 font-display">
          {navLinks}
        </ul>

        <div className="absolute right-0 top-1/2 -translate-y-1/2 flex items-center">
          <div className="hidden md:flex items-center gap-x-4">
          <a
            href="https://drive.google.com/file/d/1C7E-C9pszhlegvK1WS8urA8E1j7jdxF4/view?usp=sharing" 
            target="_blank" 
            rel="noreferrer"
            className="bg-violet-500 hover:bg-violet-700 text-white p-2 rounded-full transition-transform transform hover:scale-110"
            aria-label="Download Resume"
          >
            <Icon icon="mdi:download" className="text-xl" /> 
          </a>
          <ThemeToggle />
          </div>
        </div>

        <div className="md:hidden">
          <button
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
            className="text-black dark:text-white focus:outline-none"
          >
            <Icon icon={isMenuOpen ? "mdi:close" : "mdi:menu"} className="text-3xl" />
          </button>
        </div>
      </div>

      <div className={`md:hidden mt-4 ${isMenuOpen ? '' : 'hidden'}`}>
        <ul className="bg-white dark:bg-neutral-800 rounded-2xl border border-gray-200 dark:border-neutral-700 flex flex-col items-center space-y-2 p-4">
          {navLinks}
          <li className="pt-4">
             <a
              href="https://drive.google.com/file/d/1C7E-C9pszhlegvK1WS8urA8E1j7jdxF4/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
              download="Shobha_Garg_Resume.pdf"
              className="bg-violet-400 hover:bg-violet-500 text-display text-white font-bold py-2 px-6 rounded-full flex items-center gap-x-2"
            >
              <Icon icon="mdi:download" />
              Resume
            </a>
          </li>
          <li>
            <ThemeToggle />
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;